export const UPDATE_STEP = 'UPDATE_STEP';
export function updateStep(step) {
  return {
    type: UPDATE_STEP,
    step,
  };
}

export const SET_MENU_MODAL = 'SET_MENU';
export function setMenuModal(name, menu) {
  return {
    type: SET_MENU_MODAL,
    name,
    menu,
  };
}

export const SHOW_MODAL = 'SHOW_MODAL';
export function showModal(type, menu) {
  let payload = {};
  switch (type) {
    case 'persist':
      payload = {
        showCreateMenuModal: true,
        menu,
      };
      break;
    case 'delete':
      payload = {
        showDeleteMenuModal: true,
        menuDelete: menu,
      };
      break;
    case 'edit-rules':
      payload = {
        showEditMenuModal: true,
        menu,
      };
      break;
    case 'duplicate':
      payload = {
        showDuplicateMenuModal: true,
        menu,
      };
      break;
    case 'publish':
      payload = {
        showDisabledMenuModal: true,
        showPublishMenuModal: true,
        publishMenu: menu,
      };
      break;
    case 'edit-confirmation':
      payload = {
        showEditConfirmationMenuModal: true,
      };
      break;
    default:
      payload = {
        showCreateMenuModal: true,
      };
      break;
  }

  return {
    type: SHOW_MODAL,
    payload,
  };
}

export const CLOSE_MODAL = 'CLOSE_MODAL';
export function closeModal() {
  return {
    type: CLOSE_MODAL,
  };
}



// WEBPACK FOOTER //
// ./src/store/menuModal/actions.js